import type { HandleClientError } from '@sveltejs/kit';
import { logError } from '$lib/logger';

export const handleError: HandleClientError = ({ error, event }) => {
	const err = error as Error;
	logError('Client error', err, {
		url: event.url.href,
		route: event.route.id,
	});
	
	return {
		message: 'An unexpected error occurred',
	};
};
